module.exports = __webpack_public_path__ + "static/media/CHAP01-ENCADRE-RODIER.e125e8ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/StaticElement/img/CHAP01-ENCADRE-RODIER.png
// module id = 277
// module chunks = 0